import Konva from 'konva'
import { Vector2d } from 'konva/lib/types'

/**
 * 矩阵接口
 */
export interface RectSize {
  x: number
  y: number
  width: number
  height: number
  scaleX: number
  scaleY: number
  rotation: number
  offset: {
    x: number
    y: number
  }
}

/**
 * 尺寸参数接口
 */
export interface rulerParams {
  space: number // 刻度间距
  startCoord: Vector2d // 刻度起始坐标
  step: number // 刻度显示步长
}

export type referenceType = 'horizontal' | 'vertical'

export interface referenceLineParams {
  id?: string // 参考线 ID
  type: referenceType // 线类型
  pointerPosition: Vector2d // 指针位置
  isTemp?: boolean // 是否是临时线
}

export interface referenceLineSet {
  id: string
  type?: referenceType
  x?: number
  y?: number
}

/**
 * 吸附捕捉参数接口
 */
export interface snappingEdges {
  guide: number
  offset: number
  snap: string
}

export interface itemBounds {
  vertical: snappingEdges[]
  horizontal: snappingEdges[]
}

export interface lineGuideStops {
  vertical: number[]
  horizontal: number[]
}

export interface guideResult {
  lineGuide: number
  snap: string
  offset: number
  orientation: string
}

export interface guideDiffResult {
  lineGuide: number
  snap: string
  offset: number
  diff: number
}

export type allowSnapType = Konva.Line | Konva.Transformer | Konva.Rect

interface nodeStyle {
  uuid: string
  x?: number
  y?: number
  width?: number
  height?: number
  scaleX?: number
  scaleY?: number
  rotation?: number
}

export enum GeneralMode {
  None = 'none',
  ReadOnly = 'ReadOnly',
  Editable = 'Editable',
}

export interface StageState {
  id: string // 画布 ID
  parentId: string // 画布父级 ID， 父级的宽高会影响到当前场景的宽高
  sceneId: string // 场景 ID，该场景的偏移值会影响画布中的元素位置
  sceneOffset: Vector2d // 场景偏移值
  preStyle: nodeStyle[] // 场景元素变化前的样式， 历史记录用
  afterStyle: nodeStyle[] // 场景元素变化后的样式， 历史记录用
  showRuler: boolean // 是否显示标尺
  allowSnapping: boolean // 是否允许吸附
  isFocusin: boolean // 是否处于聚焦节点状态
  isTransform: boolean // 判断当前是否在变换状态，如拖拽、缩放、旋转等
  mode: {
    drawLine: GeneralMode
    drawLineArea: GeneralMode
  }
}
